module.exports = __webpack_public_path__ + "img/13_14.9eff2581.png";